import { createFileRoute } from '@tanstack/react-router';
import { SessionsPage, validateSessionsSearch } from '@/features/settings/AgentsPages';

export const Route = createFileRoute('/app/settings/agents/sessions/')({
  validateSearch: validateSessionsSearch,
  component: function SessionsRoute() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    return <SessionsPage search={search} onSearch={(s) => void navigate({ search: s, replace: true })} />;
  },
  staticData: { title: 'Agent sessions · Settings' },
});
